import { CanMarshal } from "./canMarshal.model";

export class PlaceHolder extends CanMarshal<PlaceHolder> {}